/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VariableSettingDto } from './variableSettingDto';


export interface VariableSettingsResponse { 
    variables?: Array<VariableSettingDto>;
    page?: number;
    size?: number;
    gea_puid?: string;
    fetched_at?: string;
    total_elements?: number;
    total_pages?: number;
}

